import React from 'react';
import Testimonial from '../components/Testimonial';
import PhotoGalleryHome from './PhotoGalleryHome';

const Div = () => {
    return (
        <div className="section bg_image_3">
            <PhotoGalleryHome />
            <Testimonial />
        </div>
    );
};

export default Div;